import cn from 'classnames';
import React from 'react';

import { IButton } from '../../interfaces';

import { buttonStyles } from '@dealroadshow/uikit/core/components/Button';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

interface IButtonProps {
  buttonConfig?: IButton,
  blueButtonConfig?: IButton,
}

const getBlueButtonComponent = (buttons: IButtonProps) => {
  if (buttons.blueButtonConfig.component) {
    const Component = buttons.blueButtonConfig.component;
    return <Component />;
  }
  if (!buttons.blueButtonConfig.content) {
    return null;
  }

  if ('link' in buttons.blueButtonConfig) {
    return (
      <a
        data-test={ buttons.blueButtonConfig.name }
        className={ cn(buttonStyles.btn, buttonStyles.action) }
        href={ `${ buttons.blueButtonConfig.link }` }
        target="_blank"

      >{ buttons.blueButtonConfig.content }
      </a>
    );
  }
  return (
    <button
      type="button"
      name={ buttons.blueButtonConfig.name }
      data-test={ buttons.blueButtonConfig.name }
      className={ cn(buttonStyles.btn, buttonStyles.action) }
      onClick={ buttons.blueButtonConfig.onClick }
    >
      { buttons.blueButtonConfig.content }
    </button>
  );
};

const getButtonComponent = (buttons: IButtonProps) => {
  const className = cn(buttonStyles.btn, buttonStyles.text, {
    [spacesStyles.pn]: !buttons.blueButtonConfig.content && !buttons.blueButtonConfig.component,
  });

  return (
    <a
      data-test={ buttons.buttonConfig.name }
      className={ className }
      href={ `${ buttons.buttonConfig.link }` }
      target="_blank"

    >
      { buttons.buttonConfig.content }
    </a>
  );
};

// TODO: Oles Bolotniuk to address refactoring of this to someone (Create ticket). I'm not sure why this component
// exists
const Buttons = (props: { buttons: IButtonProps }) => (
  <>
    { props.buttons.blueButtonConfig && getBlueButtonComponent(props.buttons) }
    { props.buttons.buttonConfig && getButtonComponent(props.buttons) }
  </>
);

export default Buttons;
